import { render, staticRenderFns } from "./Cambios_personal.vue?vue&type=template&id=42cd6d34"
import script from "./Cambios_personal.vue?vue&type=script&lang=js"
export * from "./Cambios_personal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports